import { ADMIN_LEVEL_GROUPS, GROUP_BILLING_SPECIALISTS } from "constants/staff";
import {
  INSURER_CREDIT_ENTRY_TYPE,
  INSURER_CREDIT_REASON_CODE,
  InsurerCreditEntryType,
  InsurerCreditReasonCode
} from "services/types/insurer-credit-ledger-report.type";
import { GroupType } from "services/types/staff.type";

// Mirrors the backend's `insurer_credit_ledger_report` access policy statement
// (accounts/0395). Anyone outside these groups gets a 403 from the API, so the
// route and the nav entry are hidden from them rather than leading to a dead end.
export const INSURER_CREDIT_LEDGER_GROUPS: GroupType[] = [
  ...ADMIN_LEVEL_GROUPS,
  GROUP_BILLING_SPECIALISTS
];

export const INSURER_CREDIT_LEDGER_PATH = "/reports/insurer-credit-ledger";
export const INSURER_CREDIT_LEDGER_ENTRIES_PATH = `${INSURER_CREDIT_LEDGER_PATH}/entries`;

export const ENTRY_TYPE_LABELS: Record<InsurerCreditEntryType, string> = {
  [INSURER_CREDIT_ENTRY_TYPE.CREDIT]: "Credit",
  [INSURER_CREDIT_ENTRY_TYPE.APPLICATION]: "Application",
  [INSURER_CREDIT_ENTRY_TYPE.ADJUSTMENT]: "Adjustment",
  [INSURER_CREDIT_ENTRY_TYPE.REVERSAL]: "Reversal"
};

export const REASON_CODE_LABELS: Record<InsurerCreditReasonCode, string> = {
  [INSURER_CREDIT_REASON_CODE.DEVICE_RETURN]: "Device Return",
  [INSURER_CREDIT_REASON_CODE.CANCELLATION]: "Cancellation",
  [INSURER_CREDIT_REASON_CODE.OVERPAYMENT]: "Overpayment",
  [INSURER_CREDIT_REASON_CODE.TAKE_BACK]: "Take-Back",
  [INSURER_CREDIT_REASON_CODE.BACKFILL]: "Backfill",
  [INSURER_CREDIT_REASON_CODE.WRITE_OFF]: "Write-Off",
  [INSURER_CREDIT_REASON_CODE.CORRECTION]: "Correction"
};

export const ENTRY_TYPE_OPTIONS = Object.values(INSURER_CREDIT_ENTRY_TYPE).map(
  (value) => ({ value, label: ENTRY_TYPE_LABELS[value] })
);

export const REASON_CODE_OPTIONS = Object.values(
  INSURER_CREDIT_REASON_CODE
).map((value) => ({ value, label: REASON_CODE_LABELS[value] }));
